// Plain-word translations of AnswerSheetScan.warnings codes. Codes come from
// the reader (api/paper/omr.py) and the confirm/patch flow (api/paper/results.py);
// see eltest_backend api/school_panel/views/paper_sheets.py for where they land
// on the scan row.
const STATIC_LABELS: Record<string, string> = {
  roll_unreadable: 'Roll number unreadable',
  roll_unknown: 'No student with that roll number',
  roll_duplicate: 'Same roll number as another sheet',
  blank_over_threshold: 'Many blank rows',
  no_qr: 'No QR code found',
  qr_mismatch: 'Sheet from another exam',
  no_fiducials: 'Corner marks not found',
  unreadable_image: 'Image unreadable',
  teacher_scores_missing: 'Written questions not marked',
  paper_result: 'Already has a confirmed sheet',
};

function rowCount(spec: string): number {
  return spec.split(',').map((s) => s.trim()).filter(Boolean).length;
}

/** Turns one warning code (e.g. "multi:1,4" or "roll_unreadable") into a short, readable chip label. */
export function warningLabel(code: string): string {
  if (code in STATIC_LABELS) return STATIC_LABELS[code];
  if (code.startsWith('multi:')) {
    const n = rowCount(code.slice('multi:'.length));
    return `${n} row${n === 1 ? '' : 's'} marked twice`;
  }
  if (code.startsWith('low_confidence:')) {
    const n = rowCount(code.slice('low_confidence:'.length));
    return `${n} row${n === 1 ? '' : 's'} unclear`;
  }
  // Unknown code: show it as-is rather than hide it, so a reader-side addition
  // is at least visible until this map is updated.
  return code;
}
